import { Component, Inject } from '@angular/core';
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthServices, AlertServices, AppServices } from '@services';
import { AuthModel } from '@models';

@Component({
    selector: 'app-verification',
    templateUrl: './verification.component.html',
    styleUrls: ['./verification.component.scss']
})

export class VerificationComponent {

    AuthTokenObject: AuthModel = new AuthModel();
    VerificationForm: FormGroup;
    HiddenPassword=true;
    isLoading = false;
    isDisabled = false;

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        @Inject('AlertServices') private _alertServices: AlertServices,
        @Inject('AppServices') private _appServices: AppServices,
        private router: Router,
        private formBuilder: FormBuilder,
    ) { 

        this.VerificationForm = this.formBuilder.group({
            AuthCode: ['', [Validators.required]],
        });

    }

    EnterKeyTrigger(_event: KeyboardEvent) {
        if (_event.keyCode === 13) {
            this.onVerification();
            _event.stopPropagation();
            _event.preventDefault();
        }
    }

    ngOnInit() {

        //IF is Authorized then Redirect to App
        if (this._authServices.isAuthorized()) { this._authServices._startApp() }        

    }

    CheckHealthStatus() {
        let healthStatus: boolean = false;
        this.router.navigate(['maintenance'])
    }


    onVerification() {       

        if (this.VerificationForm.valid) {

            this.isDisabled = true;
            setTimeout(() => {
                this.isDisabled = false;
            }, 60000);

            var AuthCode = this.VerificationForm.value['AuthCode']
            this.isLoading = true;

            this._authServices.Verify(AuthCode).subscribe(
                () => {
                    this.isLoading = false;
                }, (_error) => {
                    this.isLoading = false;
                    this.isDisabled = false;
                    const _ErrorResponse = JSON.parse(_error._body)
                    this._alertServices.ShowMessage( 'error' , 'app.trn-error-title' , _ErrorResponse.ErrorMessage );
                });

        }

    }

    goToLogin() {
        this._appServices.Logout()
    }

    ResendCode(){

        this.isDisabled = true;
        setTimeout(() => {
            this.isDisabled = false;
        }, 60000);

     }

}
